import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MenuService } from '../../shared/menu.service';
import { BladwijzersService } from '../bladwijzers.service';
import { IBladwijzerDb } from '../../shared/offline/cobradb';
import { AppRoutingService } from '../../shared/app-routing.service';
import { createCmdFactory } from '@cevi/rxjscommands';
import { map } from 'rxjs/operators';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';


interface IRecenteBladwijzersVm {
  bladwijzers: IBladwijzerDb[];
}

@Component({
    selector: 'app-recente-bladwijzers',
    templateUrl: './recente-bladwijzers.component.html',
    styleUrls: ['./recente-bladwijzers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, NgClass, AsyncPipe],
    providers:[BladwijzersService]
})
export class RecenteBladwijzersComponent implements OnInit {

  vm$: Observable<IRecenteBladwijzersVm>;
  vm: IRecenteBladwijzersVm;
  detailAgendapuntSubj = new Subject<IBladwijzerDb>();

  constructor(
    private menuService: MenuService,
    private appRoutingService: AppRoutingService,
    private bladwijzersService: BladwijzersService) {

    const cmdFactory = createCmdFactory<IRecenteBladwijzersVm>();
    cmdFactory.addMapAction(this.navigateToDetailPunt$, 'navigateToDetailPunt');
    this.vm$ = cmdFactory.merge(this.getInitial$());

  }

  getInitial$ = () => this.bladwijzersService.getRecenteBladwijzers().pipe(
    map(bladwijzers => ({ bladwijzers } as IRecenteBladwijzersVm))
  )

  getBladwijzerId = (_: number, bladwijzer: IBladwijzerDb) => bladwijzer.Id;

  ngOnInit() { }

  private navigateToDetailPunt$ = this.detailAgendapuntSubj.pipe(
    map( bladwijzer => (vm: IRecenteBladwijzersVm)=> {
      this.menuService.closeAllFlyouts();
      this.appRoutingService.createNavigateToDetailZittingHistoryItem(bladwijzer.ZittingId);
      this.appRoutingService.navigateToDetailPunt(bladwijzer.ZittingId, bladwijzer.AgendapuntId);
      return vm;      
    })
  )

}
